module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_flow_arrow-a44b65ecfb40083a5719e7383d713bf0.svg";